import axios from 'axios';

export const apiClientProductos = axios.create({
    //baseURL: 'http://localhost:3500/api',
    baseURL: process.env.REACT_APP_API_BASE_URL+ "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

apiClientProductos.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); 
        if(token) {
            config.headers.Authorization = `Bearer ${token}`;
        }   
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClientProductos.interceptors.response.use(
    (response) => response, // Si la respuesta es exitosa, simplemente retorna
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            //Token expirado o inválido
            console.warn("Token Expirado o inválido. Redirigiendo al login...");
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
)